import { zodTransformFirestoreTimestampToDate } from "../../utils/zodUtils.mjs";
import { zodFlavorId } from "../ids.mjs";
import { z as z$1 } from "zod";

// src/models/projections/tellescopeEnduserProjection.ts
const firestoreDate = z$1.any().transform(zodTransformFirestoreTimestampToDate);
/** Fixed doc id under `customers/{customerId}/projections/tellescopeEnduser`. */
const TELLESCOPE_ENDUSER_PROJECTION_KEY = "tellescopeEnduser";
/**
* Lean client gate for Tellescope enduser readiness.
* Path: `customers/{customerId}/projections/tellescopeEnduser`.
*/
const tellescopeEnduserProjectionSchema = z$1.object({
	id: zodFlavorId(),
	/** True when L4 `tellescope_endusers/{customerId}` has `vendorNativeId`. */
	patientExists: z$1.boolean(),
	inSync: z$1.boolean().default(false),
	createdAt: firestoreDate,
	updatedAt: firestoreDate
});
/** Pub/Sub ordering key for tellescopeEnduser projection resolve. */
function buildTellescopeEnduserProjectionOrderingKey(customerId) {
	return `customers/${customerId}/projections/${TELLESCOPE_ENDUSER_PROJECTION_KEY}`;
}

export { TELLESCOPE_ENDUSER_PROJECTION_KEY, buildTellescopeEnduserProjectionOrderingKey, tellescopeEnduserProjectionSchema };
//# sourceMappingURL=tellescopeEnduserProjection.mjs.map